<template>
  <div class="top-nav">
    <v-navigation-drawer v-model="drawer" app right temporary>
      <div class="fill-height d-flex flex-column justify-space-between">
        <div>
          <v-list
            class="py-0 link-list"
            v-if="
              !userBelepve && aktualisProjekt && aktualisProjekt.BelepesGombFl
            "
          >
            <v-list-item class="px-3" @click="OpenLoginModal">
              <v-icon class="fa-fw mr-1 font-size-lg">
                fa-sign-in-alt
              </v-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nyelvesites['belepek_text'] }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list class="py-0 link-list" v-if="isMobile && userBelepve">
            <v-list-item class="px-3" @click="Logout">
              <v-icon class="fa-fw mr-1 font-size-lg">
                fa-sign-out-alt
              </v-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nyelvesites['kilepek_text'] }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider
            v-if="aktualisProjekt && aktualisProjekt.BelepesGombFl"
          ></v-divider>
          <div v-if="isMobile">
            <v-expansion-panels
              multiple
              tile
              :accordion="true"
              class="kategoriak"
              v-if="hirKategoriak.length > 0"
            >
              <v-expansion-panel
                v-for="kategoria in hirKategoriak"
                :key="kategoria.Id"
              >
                <v-expansion-panel-header>
                  {{ kategoria.Nev }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list class="py-0" dense>
                    <v-list-item-group color="primary">
                      <template v-for="(alkategoria, i) in kategoria.Kategoria">
                        <v-list-item
                          :key="alkategoria.Id"
                          :to="{
                            name: 'Hirek',
                            params: { id: alkategoria.Id },
                          }"
                        >
                          <v-list-item-icon
                            v-if="alkategoria.Icon"
                            class="justify-center mr-4"
                          >
                            <v-icon v-text="alkategoria.Icon"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="alkategoria.Nev"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider
                          class="primary"
                          v-if="i < kategoria.Kategoria.length - 1"
                          :key="'d' + alkategoria.Id"
                        ></v-divider>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div v-else>
              <slot>
                <k-nodata-info>
                  <template v-slot:icon>
                    <i class="fas fa-clipboard-list"></i>
                  </template>
                  <template v-slot:text>
                    {{ nyelvesites['nincs_fokategoria_text'] }}
                  </template>
                </k-nodata-info>
              </slot>
            </div>
          </div>
          <v-list class="py-0 link-list" dense v-if="linkek.length > 0">
            <template v-for="link in linkek">
              <router-link
                v-if="link.Cikk"
                :key="link.Id"
                class="v-list-item v-list-item--link theme--light"
                :to="{
                  name: 'Hir',
                  params: {
                    id: link.Cikk.Azonosito,
                  },
                }"
              >
                <v-list-item-content>
                  <v-list-item-title v-html="link.Nev"></v-list-item-title>
                </v-list-item-content>
              </router-link>
              <v-list-item
                :key="link.Id"
                :href="link.Url"
                target="_blank"
                v-else
              >
                <v-list-item-content>
                  <v-list-item-title v-html="link.Nev"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <div class="px-3 mt-5" v-if="isMobile">
            <v-text-field
              v-model="searchText"
              append-icon="fa-search"
              outlined
              dense
              :placeholder="nyelvesites['kereses_placeholder_text']"
              @click:append="Kereses"
              @keyup.enter="Kereses"
            ></v-text-field>
          </div>
        </div>
        <div class="px-3 mt-5 text-center" v-if="!isMobile">
          <h4>Megnyitás telefonon</h4>
          <k-qr-code-generator
            class="my-5"
            :value="qrCodeForMobile"
            :size="150"
          ></k-qr-code-generator>
          <p class="caption">
            Irányítsa ide kameráját.
          </p>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../../functions/AppFunctions';
import { eventBus } from '../../main';
import { userService } from '../../services/UserService';
import settings from '../../settings';
import { AppStoreTypes } from '../../store/modules/app';
import { getToken } from '../../utils/token';
import { modalHandler } from '../../utils/vue/modalHandler';
export default {
  name: 'k-top-menu',
  data() {
    return {
      isBv: settings.env == 'bv',
      searchText: '',
      menuk: [
        {
          to: '/fooldal/',
          title: 'Kezdőlap',
          icon: 'fas fa-home',
        },
        {
          to: '/elozmenyek/',
          title: 'Előzmények',
          icon: 'fas fa-clipboard-list',
        },

        {
          to: '/fontosak/',
          title: 'Fontosak',
          icon: 'fas fa-bookmark',
        },
        {
          to: '/ertesitesek/',
          title: 'Értesítések',
          icon: 'fas fa-bell',
        },
        {
          to: '/profil/',
          title: 'Profil',
          icon: 'fas fa-user',
        },
      ],
    };
  },
  mounted() {},
  created() {},
  methods: {
    Kereses() {
      this.$router.push({ name: 'Kereses', query: { text: this.searchText } });
      this.searchText = '';
    },
    OpenLoginModal() {
      modalHandler.OpenModal('login-modal', null, { maxWidth: '400px' });
      this.drawer = false;
    },
    async Logout() {
      await userService.Logout();

      if (this.$route.name != 'Fooldal') {
        this.$router.push({ name: 'Fooldal' });
      }

      let url = new URL(location.href);
      url.searchParams.delete('token');
      url.searchParams.delete('apiKey');
      location.href = url.toString();
    },
  },
  computed: {
    ...mapGetters({
      hirKategoriak: AppStoreTypes.hirKategoriak.getAll,
      user: AppStoreTypes.user.get,
      linkek: AppStoreTypes.linkek.getAll,
    }),
    qrCodeForMobile() {
      let token = getToken();
      // token nem reaktív, user igen
      let dependency = this.user;
      return `${location.origin}#/?bottomBar=true&token=${token}`;
    },
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    userBelepve() {
      return this.user?.Id > 0;
    },
    drawer: {
      get() {
        return this.$store.getters[AppStoreTypes.isDrawerOpened.get];
      },
      set(value) {
        this.$store.dispatch(AppStoreTypes.isDrawerOpened.set, { value });
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  components: {},
};
</script>
